import { Button, Card, Modal, Popconfirm, Space, Table, Tabs, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAPIUser } from "../../../_helper/User/UserProvider";
import { PoApprovalsApi } from "../../../api";
import { fetchOrganisationDetails } from "../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../context/logging";
import ColumnConfig from "../Project/Budget/column-config";
import PODetails from "../Project/Po/poDetails";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const Approvals = (props) => {
  const { user } = props.settings;
  const { dispatch } = props;
  const history = useNavigate();
  const logger = React.useContext(LoggerContext);

  const [activeTab, setActiveTab] = useState("1");
  const { userDetails, setUserDetails } = useAPIUser();
  const [modal1Visible, setModal1Visible] = useState(false);
  const [approvalList, setApprovalList] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pendingApprovalList, setPendingApprovalList] = useState([]);
  const [poDetails, setPoDetails] = useState(null);
  const [organisationDetails, setOrganisationDetails] = useState(null);
  const { TabPane } = Tabs;
  useEffect(() => {
    fetchPending({ is_approved: false, is_rejected: false });
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });

    logger.log(LogEvents.approvals, {});
    // fetchTaxOptions();
  }, []);

  const fetchPending = (params = {}) => {
    setLoading(true);
    axios
      .get(`${PoApprovalsApi}`, { params: { ...params } })
      .then((res) => {
        setPendingApprovalList(res.data);

        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong!");
        setLoading(false);
      });
  };

  const fetchApproved = (params = {}) => {
    axios
      .get(`${PoApprovalsApi}`, { params: { ...params } })
      .then((res) => {
        setApprovalList(res.data);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  // const fetchTaxOptions = () => {
  //   axios.get(`${TaxOptionAPI}`).then((res) => {
  //     setTaxOptions(
  //       res.data?.filter(
  //         (each) =>
  //           each.organisation === user?.organisation?.organisation_id
  //       )
  //     );
  //   });
  // };

  const onApprove = (po) => {
    logger.log(LogEvents.approvePo, {});

    const formData = new FormData();
    formData.append("is_approved", true);
    axios
      .put(`${PoApprovalsApi}${po}/`, formData)
      .then((res) => {
        fetchPending({ is_approved: false, is_rejected: false });
        toast.success("PO Approved Successfully!");
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  const onRejected = (po) => {
    logger.log(LogEvents.rejectPo, {});

    const formData = new FormData();
    formData.append("is_rejected", true);
    axios
      .put(`${PoApprovalsApi}${po}/`, formData)
      .then((res) => {
        fetchPending({ is_approved: false, is_rejected: false });
        toast.success("PO rejected!");
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  const handleTabChange = (key) => {
    if (key === "1") {
      fetchPending({ is_approved: false, is_rejected: false });
    } else {
      fetchApproved({});
    }
  };
  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };
  const columnsPending = [
    {
      title: "PO Number",
      key: "po",
      render: (data) => <span>{data?.po?.po_number}</span>,
    },
    {
      title: "Project",
      key: "project",
      render: (data) => <span>{data?.po?.project?.project_name}</span>,
    },
    {
      title: "Project Code",
      key: "project_code",
      render: (data) => <span>{data?.po?.project?.project_code}</span>,
    },
    {
      title: "Vendor",
      key: "vendor",
      render: (data) => <span>{data?.po?.vendor?.name}</span>,
    },
    {
      title: "Requested By",
      key: "requested_by",
      render: (data) => <span>{data?.po?.created_by}</span>,
    },
    {
      title: "Delivery Date",
      key: "delivery_date",
      render: (data) => (
        <span>{getFormattedDate(data?.po?.delivery_date)}</span>
      ),
    },
    {
      title: "Creation Date",
      key: "created_at",
      render: (data) => <span>{getFormattedDate(data?.po?.created_at)}</span>,
    },
    {
      title: "Total",
      key: "total",
      render: (data) => <span>{data?.po?.total_po_raised_amount}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (data) => (
        <Space>
          <Tag
            onClick={() => {
              // setPoDetails(data?.po);
              dispatch({
                type: "settings/CHANGE_SETTING",
                payload: {
                  setting: "project",
                  value: data?.po?.project,
                },
              });
              logger.log(LogEvents.seePoApprovalDetails, {});
              history("/app/project/po-details/" + data?.po?.id, {
                // state: {
                //   details: data?.po,
                //   organisationDetails: organisationDetails,
                //   projectDetails: data?.po?.project,
                //   taxOptions: taxOptions,
                // },
              });
              // setModal1Visible(true);
            }}
            color={"purple"}
            style={{ cursor: "pointer" }}
          >
            See Details
          </Tag>
          <Popconfirm
            onConfirm={() => onApprove(data?.id)}
            okText={"Yes"}
            cancelText={"No"}
            title={"Do you want to approve?"}
          >
            <Tag style={{ cursor: "pointer" }} color={"success"}>
              Approve
            </Tag>
          </Popconfirm>
          <Popconfirm
            onConfirm={() => onRejected(data?.id)}
            okText={"Yes"}
            cancelText={"No"}
            title={"Do you want to reject?"}
          >
            <Tag style={{ cursor: "pointer" }} color={"error"}>
              Reject
            </Tag>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const columnsApproved = [
    {
      title: "PO Number",
      key: "po",
      render: (data) => <span>{data?.po?.id}</span>,
    },
    {
      title: "PO Number",
      key: "po",
      render: (data) => <span>{data?.po?.id}</span>,
    },
    {
      title: "Project",
      key: "project",
      render: (data) => <span>{data?.po?.project?.project_name}</span>,
    },
    {
      title: "Vendor",
      key: "vendor",
      render: (data) => <span>{data?.po?.vendor?.name}</span>,
    },
    {
      title: "Requested By",
      key: "requested_by",
      render: (data) => <span>{data?.po?.created_by}</span>,
    },
    {
      title: "Delivery Date",
      key: "delivery_date",
      render: (data) => (
        <span>{getFormattedDate(data?.po?.delivery_date)}</span>
      ),
    },
    {
      title: "Creation Date",
      key: "created_at",
      render: (data) => <span>{getFormattedDate(data?.po?.created_at)}</span>,
    },
    {
      title: "Total",
      key: "total",
      render: (data) => <span>{data?.po?.total_po_raised_amount}</span>,
    },
    {
      title: "Status",
      key: "status",
      render: (data) => (
        <Space>
          <Tag color={"warning"}>Pending</Tag>
        </Space>
      ),
    },
  ];

  const [userSelectedColumns, setUserSelectedColumns] =
    useState(columnsPending);

  const getUserSelectedColumns = () => {
    return userSelectedColumns.filter((column) => {
      return column?.selected !== false;
    });
  };

  useEffect(() => {
    if (props.settings?.user?.user_selected_columns?.approval_table) {
      const columnSettings = userSelectedColumns?.map((col) => {
        let currentCol =
          props.settings?.user?.user_selected_columns?.approval_table?.find(
            (column) => col.key == column?.key
          );
        return { ...col, selected: currentCol?.selected ?? true };
      });
      setUserSelectedColumns(columnSettings);
    }
  }, [props.settings?.user?.user_selected_columns?.approval_table]);
  return (
    <>
      <div>
        <Card>
          <section className="d-flex justify-content-end align-items-center">
            <ColumnConfig
              columns={userSelectedColumns}
              setCols={(cols) => setUserSelectedColumns(cols)}
              mode="approval"
              onClick={() => {
                logger.log(LogEvents.customizePoMenu, {});
              }}
            />
          </section>
          <Table
            loading={loading}
            columns={getUserSelectedColumns()}
            dataSource={pendingApprovalList}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
          {/* <Tabs
            defaultActiveKey="1"
            type="card"
            onChange={(e) => {
              handleTabChange(e);
            }}
          >
            <TabPane tab="Approval for me" key="1">
              <Table
                columns={columnsPending}
                dataSource={pendingApprovalList}
                rowKey={(record) => record.id}
                pagination={false}
                scroll={{ x: "max-content" }}
              />
            </TabPane>
            <TabPane tab="PO/WOs by me" key="2">
              <Table
                columns={columnsApproved}
                dataSource={approvalList}
                rowKey={(record) => record.id}
                pagination={false}
                scroll={{ x: "max-content" }}
              />
            </TabPane>
          </Tabs> */}
        </Card>
      </div>
      <Modal
        title="PO Details"
        width={"1000px"}
        visible={modal1Visible}
        onCancel={() => {
          setModal1Visible(false);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setModal1Visible(false);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <PODetails
          details={poDetails}
          organisationDetails={organisationDetails}
          projectDetails={props.settings.project}
          // taxOptions={taxOptions}
        />
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(Approvals);
